import { useMemo } from 'react';
import { UKRAINIAN_DOCUMENT_TYPES } from '~/constants/docs.ts';
import { useDocumentsQuery } from '~/queries/useDocumentsQuery.ts';
import { TDocTypeItem } from '~/store/types';
import { TAutocompleteOption } from '~/components/AutocompleteField/types';
interface UseDocumentTypesReturnRevoke {
  docTypes: TAutocompleteOption[];
  docType: TDocTypeItem[] | null | undefined;
}

export const useDocumentTypesRevoke = (): UseDocumentTypesReturnRevoke => {
  const { personalDocs: docType, personalDocOptions, isLoading } = useDocumentsQuery();

  const docTypes = useMemo((): TAutocompleteOption[] => {
    if (isLoading) {
      return [{ value: '', label: '' }];
    }

    const allowedValues = UKRAINIAN_DOCUMENT_TYPES.map(String);

    return personalDocOptions
      .filter((option: TAutocompleteOption) => !!option.value && !!option.label)
      .filter((docTypeOption: TAutocompleteOption) => allowedValues.includes(docTypeOption.value));
  }, [personalDocOptions, isLoading]);

  return { docTypes, docType };
};
